import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { MealMenu } from '@/types/Meal.ts'
import { DELETE_DAYCARE_MEAL_MENU } from '@/modules/API/meal/daycareSettingsHandler.ts'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'

interface ConfirmDeleteMealMenuDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    menu: MealMenu
    refetch: () => void
}

const ConfirmDeleteMealMenuDialog: FunctionComponent<ConfirmDeleteMealMenuDialogProps> = ({
    open,
    handleClose,
    daycareId,
    menu,
    refetch
}: ConfirmDeleteMealMenuDialogProps) => {
    const { t } = useTranslation()
    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteMealMenu] = useMutation(DELETE_DAYCARE_MEAL_MENU, {
        variables: {
            daycareId,
            id: menu.id
        },
        onCompleted: () => {
            refetch()
            showNotificationSuccess(t('mealMenuDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('mealMenuDeletedError'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deleteMealMenu')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>
                        {t('deleteMealMenuMessage')} <span>{menu.menu}</span> ?{' '}
                    </p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={() => deleteMealMenu()}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteMealMenuDialog
